import React, { useEffect, useState, useCallback, useContext, useRef } from "react";
import api, { BASE_URL } from "../../Utils/api";
import TiposPagamentoModal from "./TiposPagamentoModal";
import ConfiguracoesCamposModal from "../Configuracoes/ConfiguracoesCampos/ConfiguracoesCamposModal";
import GridPadrao from "../GridPadrao/GridPadrao";
import PageHeader from "../PageHeader/PageHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import { GlobalContext } from "../../Utils/GlobalContext";
import { useFeedback } from "../Generals/Feedback/FeedbackContext";


function TiposPagamento() {
  const { toast, confirm } = useFeedback();
  const [tiposPagamento, setTiposPagamento] = useState([]);
  const [selectedTipoPagamento, setSelectedTipoPagamento] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showConfigCamposModal, setShowConfigCamposModal] = useState(false);
  const [tccPagamentoId, setTccPagamentoId] = useState(null);
  const { globalData } = useContext(GlobalContext);
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id");
  const token = localStorage.getItem("authToken");
  const exclusoesEmAndamento = useRef(new Set());
  const permiteEdicao = "N"; // Ajuste para "S" ou "N" , de Configurações ou Cadastros Globais de qualquer entidade

  // Definindo as colunas da tabela
  const columns = [
    { Header: "Nome", accessor: "descricao" },
    { Header: "Situação", accessor: "situacao" },
  ];

  // Resolve o TCC (tipos_configuracoes_campos) correspondente a Pagamentos pelo nome/descrição.
  useEffect(() => {
    if (!entidadeID || !token) return;
    api
      .get(`${BASE_URL}/api/configuracaoCampos/ListarTiposConfiguracoesCampos/${entidadeID}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const lista = Array.isArray(res.data?.data) ? res.data.data : [];
        const match = lista.find((t) =>
          (t.nome || t.descricao || "").toLowerCase().includes("pagamento")
        );
        setTccPagamentoId(match?.id ?? null);
      })
      .catch(() => setTccPagamentoId(null));
  }, [entidadeID, token]);

  const handleOpenConfigCampos = () => {
    if (tccPagamentoId != null) setShowConfigCamposModal(true);
  };

  // Função para buscar os tipos de pagamento
  const fetchTiposPagamento = useCallback(() => {
    api
      .get(`${BASE_URL}/api/tiposPagamento/ListarTiposPagamento/${entidadeID}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        // Adiciona `permiteEdicao` a cada item retornado
        const tiposComPermissao = response.data.data.map((tipo) => ({
          ...tipo,
          permiteEdicao: permiteEdicao, // adiciona a permissão para cada item
        }));
        setTiposPagamento(tiposComPermissao);
      })
      .catch((error) => {
        console.error("Erro ao buscar os tipos de pagamento:", error);
      });
  }, [token, entidadeID, permiteEdicao]);

  // Função para buscar os dados da API na montagem do componente
  useEffect(() => {
    fetchTiposPagamento();
  }, [fetchTiposPagamento]);

  const handleEdit = (tipo) => {
    setSelectedTipoPagamento(tipo);
    setShowModal(true); // Abrir o modal para edição
  };

  const handleAdd = () => {
    setSelectedTipoPagamento(null); // Limpar o índice selecionado para adicionar novo
    setShowModal(true); // Abrir o modal para novo índice
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedTipoPagamento(null);
  };

  const handleExcluir = async (tipo) => {
    if (exclusoesEmAndamento.current.has(tipo.id)) return;
    exclusoesEmAndamento.current.add(tipo.id);

    try {
      const ok = await confirm(`Tem certeza que deseja excluir o tipo "${tipo.descricao}"?`);
      if (!ok) return;

      await api.delete(
        `${BASE_URL}/api/tiposPagamento/ExcluirTipoPagamento/${tipo.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchTiposPagamento();
    } catch (error) {
      if (error.response?.status === 409) {
        toast.error(error.response.data?.message || "Este tipo de pagamento está sendo utilizado.");
        return;
      }

      console.error("Erro ao excluir tipo de pagamento:", error);
      toast.error(error.response?.data?.message || "Erro ao excluir. Tente novamente.");
    } finally {
      exclusoesEmAndamento.current.delete(tipo.id);
    }
  };

  return (
    <div data-tour="tipos-pagamento-cadastro">
      <PageHeader titulo="Cadastro de Tipos de Pagamento" path="/TiposPagamento" />

      <GridPadrao
        columns={columns}
        data={tiposPagamento}
        onEdit={(configuracao) => handleEdit(configuracao, permiteEdicao)}
        onAdd={handleAdd}
        onInactivate={handleExcluir}
        onConfigCampos={tccPagamentoId != null ? handleOpenConfigCampos : undefined}
      />

      <TiposPagamentoModal
        show={showModal}
        handleClose={handleClose}
        tipoPagamento={selectedTipoPagamento}
        fetchTiposPagamento={fetchTiposPagamento}
      />

      <ConfiguracoesCamposModal
        show={showConfigCamposModal}
        handleClose={() => setShowConfigCamposModal(false)}
        configuracao={tccPagamentoId != null ? { id: tccPagamentoId } : null}
        fetchConfiguracoes={fetchTiposPagamento}
      />
    </div>
  );
}

export default TiposPagamento;
